import request from "@/api";
import type { PurchaseDemandVo, ServiceSpecialVo } from "@zhihaoscm/entity";
import { BaseService } from "@/api/services/baseService";
import { confirmable } from "@/utils/decorator/confirmable";
import type { AssignForm, AuditForm, PurchaseDemandForm, StrandingForm } from "@/entity/purchasing/intend";

export class IntendService extends BaseService<PurchaseDemandVo, PurchaseDemandVo, unknown, PurchaseDemandForm> {
    /**获取专员数据 */
    async getOfficer(keyword: string): Promise<ServiceSpecialVo[]> {
        const { data } = await this.service.get(`${this.path}/find/service?name=${keyword}`);
        return data;
    }

    /**
     * 根据ID查询
     * @param id
     */
    public async get(id: number | string) {
        const { data } = await this.service.get<PurchaseDemandVo>(`${this.path}/vo/${id}`);
        return data;
    }

    /**
     * 指派购买意向
     * @param form
     */

    public async designate(form: AssignForm) {
        return await this.service.post(`${this.path}/assign`, form);
    }

    /**
     * 搁浅意向
     */
    public async strandIntend(form: StrandingForm) {
        return await this.service.post(`${this.path}/stranding`, form);
    }

    /**开始意向 */
    @confirmable("是否开始")
    public async startIntend(id: number) {
        return await this.service.put(`${this.path}/start/${id}`);
    }

    /**提交审核 */
    @confirmable("是否提交审核")
    public async submitAudit(id: number) {
        return await this.service.post(`${this.path}/submit/${id}`);
    }
    /**审核意向 */
    public async auditIntend(form: AuditForm) {
        return await this.service.post(`${this.path}/audit`, form);
    }
    /**重置意向 */
    @confirmable("是否重置")
    public async resetIntend(id: number) {
        return await this.service.post(`${this.path}/revoke/${id}`);
    }
    /**关闭意向 */
    @confirmable("是否关闭")
    public async closeIntend(id: number) {
        return await this.service.put(`${this.path}/close/${id}`);
    }
}
export const intendService = new IntendService("/admin/purchase-demand", request.service);
